export const amountFormat = (amount, currency) => {
  if (amount === null || amount === undefined || amount === '') return '0';

  const str = amount.toString().replace(/,/g, '');
  const isNegative = str.startsWith('-');
  const [intPart, decPart] = str.replace('-', '').split('.');

  let formattedInt;
  if (String(currency || '').toUpperCase() === 'INR') {
    // Indian format: 1,23,45,678
    const lastThree = intPart.slice(-3);
    const rest = intPart.slice(0, -3);
    formattedInt = rest
      ? rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree
      : lastThree;
  } else {
    // International format: 12,345,678
    formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  return (
    (isNegative ? '-' : '') +
    formattedInt +
    (decPart !== undefined ? '.' + decPart : '')
  );
};